
import Vue from "vue";
import {SlimSelectOption} from "src/components/common/vue-slim-select/vue-slim-select";
import RespressoApi, {IntegrationProjectInfo, IntegrationTeamInfo} from "../../../api/respresso-api";
import ErrorHandler from "../../../services/error-handler";
import StorageService from "../../../services/storage-service";


export interface TeamAndProjectTarget {
  team: string;
  project: string;
  type: TeamAndProjectTargetType;
}

type TeamAndProjectTargetState = "loading" | "empty" | "picking"
type TeamAndProjectTargetType = "auto" | "user"

export default Vue.extend({
  name: "team-and-project-target-picker",
  components: {

  },
  props: {
  },
  data() {
    return {
      state: "loading" as TeamAndProjectTargetState,
      teams: [] as IntegrationTeamInfo[],
      team: undefined as IntegrationTeamInfo | undefined,
      project: undefined as IntegrationProjectInfo | undefined,
    }
  },
  computed: {

  },
  mounted() {
  },
  created() {
    this.load();
  },
  methods: {
    load: async function() {
      this.state = "loading";
      this.team = undefined;
      this.project = undefined;
      let teamId: string | null = StorageService.getLastIntegrationTeam();
      let projectId = StorageService.getLastIntegrationProject();
      const info = await ErrorHandler.tryRequest(() => RespressoApi.getIntegrationInfo());
      if(info && info.teams && info.teams.length > 0) {
        this.teams = info?.teams;
        if (teamId) {
          const selectedTeam = this.teams.find((value) => value.id === teamId || value.name == teamId);
          if (selectedTeam) {
            this.team = selectedTeam;
          }
        }
        if (!this.team) {
          if (projectId) {
            const selectedTeam = this.teams.find(
                (team) =>
                    team.projects &&
                    team.projects.some((project) => project.id === projectId || project.name == projectId),
            );
            if (selectedTeam) {
              this.team = selectedTeam;
            }
          }
        }
        if (!this.team) {
          this.team = this.teams[0];
        }
        if (this.team && this.team.projects && this.team.projects.length > 0) {
          if (projectId) {
            const selectedProject = this.team.projects.find(
                (value) => value.id === projectId || value.name === projectId,
            );
            if (selectedProject) {
              this.project = selectedProject;
            }
          }
          if (!this.project) {
            this.project = this.team.projects[0];
          }
        }
        this.state = "picking";
        this.emitTargetChange("auto");
      } else {
        this.state = "empty"
      }
    },
    emitTargetChange: function(targetType: TeamAndProjectTargetType) {
      if(this.team && this.project) {
        const targetTeamAndProject: TeamAndProjectTarget = {
          team: this.team.name,
          project: this.project.name,
          type: targetType,
        }
        this.$emit("target-change", targetTeamAndProject)
      }
    },
    createTeamSelectOptions: function(): SlimSelectOption[] {
      if (this.teams) {
        return this.teams.map((team) => {
          const option: SlimSelectOption = {
            text: team.title,
            value: team.id,
            selected: this.team ? this.team.id === team.id : false,
          };
          return option;
        });
      }
      return [];
    },
    createProjectSelectOptions: function(): SlimSelectOption[] {
      if (this.team && this.team.projects) {
        return this.team.projects.map((project) => {
          const option: SlimSelectOption = {
            text: project.title,
            value: project.id,
            selected: this.project ? this.project.id === project.id : false,
          };
          return option;
        });
      }
      return [];
    },
    onTeamSelected: function(event: any) {
      const id = event.value;
      if (id && this.teams) {
        const selection = this.teams.find((team) => team.id === id);
        if (selection && (!this.team || this.team.id !== selection.id)) {
          this.team = selection;
          if(selection.projects.length > 0) {
            this.project = this.team.projects[0];
            this.emitTargetChange(this.team.projects.length == 1 ? "user" : "auto");
          }
          this.$forceUpdate();
        }
      }
    },
    onProjectSelected: function(event: any) {
      const id = event.value;
      if (id && this.team && this.team.projects) {
        const selection = this.team.projects.find((project) => project.id === id);
        if (selection && (!this.project || this.project.id !== selection.id)) {
          this.project = selection;
          this.emitTargetChange("user");
          this.$forceUpdate();
          return;
        }
      }
    }
  }
})

